// Generated by OneAdmin on every deploy — edits here are overwritten.
// Help & About for pcakefresh: questions, videos, install, share (link + QR code), who made it.
const CONFIG = {"enabled":false,"install":true,"appName":"pcakefresh","version":"0.0.0","link":"https://priyas.mycreativeworld.app/","qr":{"size":37,"path":"M4 4h7v1h-7zM12 4h3v1h-3zM17 4h3v1h-3zM22 4h1v1h-1zM26 4h7v1h-7zM4 5h1v1h-1zM10 5h1v1h-1zM13 5h2v1h-2zM16 5h1v1h-1zM19 5h1v1h-1zM26 5h1v1h-1zM32 5h1v1h-1zM4 6h1v1h-1zM6 6h3v1h-3zM10 6h1v1h-1zM12 6h1v1h-1zM14 6h2v1h-2zM17 6h1v1h-1zM21 6h1v1h-1zM23 6h1v1h-1zM26 6h1v1h-1zM28 6h3v1h-3zM32 6h1v1h-1zM4 7h1v1h-1zM6 7h3v1h-3zM10 7h1v1h-1zM13 7h1v1h-1zM15 7h1v1h-1zM19 7h1v1h-1zM21 7h2v1h-2zM24 7h1v1h-1zM26 7h1v1h-1zM28 7h3v1h-3zM32 7h1v1h-1zM4 8h1v1h-1zM6 8h3v1h-3zM10 8h1v1h-1zM13 8h1v1h-1zM19 8h3v1h-3zM26 8h1v1h-1zM28 8h3v1h-3zM32 8h1v1h-1zM4 9h1v1h-1zM10 9h1v1h-1zM12 9h2v1h-2zM15 9h1v1h-1zM17 9h2v1h-2zM20 9h3v1h-3zM24 9h1v1h-1zM26 9h1v1h-1zM32 9h1v1h-1zM4 10h7v1h-7zM12 10h1v1h-1zM14 10h1v1h-1zM16 10h1v1h-1zM18 10h1v1h-1zM20 10h1v1h-1zM22 10h1v1h-1zM24 10h1v1h-1zM26 10h7v1h-7zM13 11h1v1h-1zM15 11h1v1h-1zM17 11h1v1h-1zM19 11h2v1h-2zM4 12h1v1h-1zM6 12h1v1h-1zM10 12h2v1h-2zM13 12h1v1h-1zM16 12h2v1h-2zM20 12h1v1h-1zM23 12h2v1h-2zM27 12h1v1h-1zM30 12h1v1h-1zM32 12h1v1h-1zM4 13h1v1h-1zM8 13h2v1h-2zM12 13h2v1h-2zM15 13h1v1h-1zM19 13h1v1h-1zM23 13h2v1h-2zM26 13h2v1h-2zM31 13h2v1h-2zM4 14h1v1h-1zM7 14h1v1h-1zM10 14h1v1h-1zM14 14h1v1h-1zM17 14h5v1h-5zM23 14h1v1h-1zM25 14h2v1h-2zM28 14h3v1h-3zM32 14h1v1h-1zM5 15h1v1h-1zM8 15h1v1h-1zM11 15h1v1h-1zM13 15h1v1h-1zM15 15h1v1h-1zM18 15h1v1h-1zM22 15h1v1h-1zM24 15h2v1h-2zM28 15h2v1h-2zM4 16h2v1h-2zM7 16h4v1h-4zM13 16h1v1h-1zM15 16h5v1h-5zM23 16h2v1h-2zM26 16h1v1h-1zM32 16h1v1h-1zM4 17h1v1h-1zM6 17h3v1h-3zM13 17h1v1h-1zM15 17h1v1h-1zM17 17h4v1h-4zM22 17h6v1h-6zM31 17h2v1h-2zM5 18h1v1h-1zM7 18h2v1h-2zM10 18h3v1h-3zM14 18h1v1h-1zM16 18h1v1h-1zM19 18h2v1h-2zM23 18h4v1h-4zM28 18h1v1h-1zM32 18h1v1h-1zM4 19h3v1h-3zM8 19h1v1h-1zM14 19h1v1h-1zM17 19h1v1h-1zM22 19h2v1h-2zM25 19h2v1h-2zM28 19h1v1h-1zM8 20h1v1h-1zM10 20h3v1h-3zM15 20h3v1h-3zM19 20h1v1h-1zM23 20h1v1h-1zM25 20h3v1h-3zM32 20h1v1h-1zM5 21h1v1h-1zM7 21h1v1h-1zM12 21h2v1h-2zM15 21h2v1h-2zM19 21h3v1h-3zM23 21h2v1h-2zM26 21h2v1h-2zM30 21h3v1h-3zM4 22h2v1h-2zM7 22h1v1h-1zM9 22h2v1h-2zM12 22h1v1h-1zM15 22h5v1h-5zM23 22h1v1h-1zM27 22h1v1h-1zM29 22h1v1h-1zM32 22h1v1h-1zM6 23h1v1h-1zM8 23h1v1h-1zM11 23h3v1h-3zM18 23h1v1h-1zM22 23h2v1h-2zM26 23h1v1h-1zM4 24h2v1h-2zM7 24h1v1h-1zM9 24h2v1h-2zM13 24h1v1h-1zM15 24h1v1h-1zM17 24h4v1h-4zM23 24h7v1h-7zM31 24h1v1h-1zM12 25h3v1h-3zM17 25h4v1h-4zM22 25h1v1h-1zM24 25h1v1h-1zM28 25h3v1h-3zM32 25h1v1h-1zM4 26h7v1h-7zM12 26h2v1h-2zM15 26h2v1h-2zM19 26h2v1h-2zM22 26h1v1h-1zM24 26h1v1h-1zM26 26h1v1h-1zM28 26h1v1h-1zM32 26h1v1h-1zM4 27h1v1h-1zM10 27h1v1h-1zM13 27h1v1h-1zM16 27h2v1h-2zM19 27h2v1h-2zM23 27h2v1h-2zM28 27h1v1h-1zM31 27h2v1h-2zM4 28h1v1h-1zM6 28h3v1h-3zM10 28h1v1h-1zM13 28h2v1h-2zM17 28h1v1h-1zM20 28h1v1h-1zM23 28h7v1h-7zM31 28h2v1h-2zM4 29h1v1h-1zM6 29h3v1h-3zM10 29h1v1h-1zM13 29h2v1h-2zM19 29h1v1h-1zM21 29h1v1h-1zM23 29h1v1h-1zM25 29h1v1h-1zM27 29h4v1h-4zM32 29h1v1h-1zM4 30h1v1h-1zM6 30h3v1h-3zM10 30h1v1h-1zM12 30h2v1h-2zM15 30h1v1h-1zM18 30h4v1h-4zM23 30h1v1h-1zM25 30h1v1h-1zM28 30h1v1h-1zM31 30h2v1h-2zM4 31h1v1h-1zM10 31h1v1h-1zM14 31h4v1h-4zM20 31h1v1h-1zM23 31h4v1h-4zM29 31h1v1h-1zM4 32h7v1h-7zM12 32h2v1h-2zM16 32h2v1h-2zM19 32h2v1h-2zM24 32h1v1h-1zM26 32h3v1h-3zM32 32h1v1h-1z"},"company":{"name":"","email":"","website":"","tagline":""},"faq":[],"media":null};

// ── OneAdmin help panel ──────────────────────────────────────────────────────────────────────
// Help & About for every app OneAdmin deploys: questions, installing the app, sharing it (link +
// QR code) and who made it. OneAdmin writes this file into the app's repo on each deploy, with the
// CONFIG above baked in then — the link is the app's last good deployment, so a share never points
// at a preview or a half-finished build.
//
// Where the button goes: the bottom-right corner, always — never into the app's own top bar. An
// app that has its own help button marks it `data-oneadmin-help`; its click opens this panel and no
// second button is added.
//
// Who sees it: in an app that signs people in, help is for the people inside, so the button stays
// off the sign-up and sign-in pages. OneAdmin's access module (src/oneadmin/access.js) says which
// kind of app this is: with Activate Signup on, the button shows once someone is signed in; with
// the app's own sign-in, once the app has a session; an app with no sign-in shows it to everyone.
//
// It takes its look from the app it lives in, never the other way round: the panel takes the
// page's background, text colour, font and accent — so it reads as part of each app, in light or dark.
//
// The questions are prepared by OneAdmin from the app's own code on each deploy (CONFIG.faq), and
// short videos of the features that take several steps are recorded by Atgent once a deploy is live
// — fetched from OneAdmin when the panel opens (CONFIG.media), so a new video needs no new deploy.
//
// An app can hand the panel its own questions too, shown first (no import needed — this file exists
// only in the deployed repo, never in the source folder):
//   window.oneadminHelpConfig = { faq: [{ q: { en, de }, a: { en, de } }], lang: "en" | "de" | () => … }
(() => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (!CONFIG.enabled || window.__oneadminHelpLoaded) return;
  window.__oneadminHelpLoaded = true;

  // ── Install ────────────────────────────────────────────────────────────────────────────────
  // The browser offers this once, early, so it is caught at import time. The install pop-down in
  // this same file holds the offer (window.oneadminInstall); this copy only says it was made.
  let deferredInstall = null;
  window.addEventListener("beforeinstallprompt", (e) => { deferredInstall = e; });
  window.addEventListener("appinstalled", () => { deferredInstall = null; if (isOpen) render(); });
  const isInstalled = () => {
    try {
      return window.matchMedia("(display-mode: standalone)").matches
        || window.matchMedia("(display-mode: window-controls-overlay)").matches
        || navigator.standalone === true;
    } catch { return false; }
  };
  const platform = () => {
    const ua = navigator.userAgent || "";
    if (/iPad|iPhone|iPod/.test(ua) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(ua))) return "ios";
    if (/Android/.test(ua)) return "android";
    return "desktop";
  };
  // An app with no web manifest cannot be installed, except as a Safari bookmark on iOS — so the
  // install part is shown only where it can actually do something.
  const installable = () => !!deferredInstall || !!(window.oneadminInstall && window.oneadminInstall.canPrompt())
    || !!document.querySelector('link[rel="manifest"]') || platform() === "ios";

  // ── Language ───────────────────────────────────────────────────────────────────────────────
  const LANG_KEY = "oneadmin.helpLang";
  let chosenLang = null;
  const appConfig = () => (window.oneadminHelpConfig && typeof window.oneadminHelpConfig === "object" ? window.oneadminHelpConfig : {});
  const lang = () => {
    if (chosenLang) return chosenLang;
    let fromApp = appConfig().lang;
    try { if (typeof fromApp === "function") fromApp = fromApp(); } catch { fromApp = null; }
    if (fromApp === "de" || fromApp === "en") return fromApp;
    try { const s = localStorage.getItem(LANG_KEY); if (s === "de" || s === "en") return s; } catch { /* storage off */ }
    return /^de\b/i.test(navigator.language || "") ? "de" : "en";
  };
  const L = (en, de) => (lang() === "de" ? de : en);

  // ── What the panel shows ─────────────────────────────────────────────────────────────────────
  const link = () => CONFIG.link || (location.origin + "/");
  // Which parts the owner shows (Manage Content → Manage App Behaviour), as OneAdmin last said.
  // Everything shows until it has said otherwise.
  const showPart = (k) => !(media && media.show && media.show[k] === false);
  const bare = (u) => String(u).replace(/^https?:\/\//, "").replace(/\/$/, "");
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  // The app's own questions first, then the ones OneAdmin prepared — as OneAdmin serves them now
  // (the owner may have left some out, in Manage App Behaviour), or as baked in at deploy while that
  // answer has not arrived; a question asked twice is shown once.
  const faq = () => {
    if (!showPart("faq")) return [];
    const own = Array.isArray(appConfig().faq) ? appConfig().faq : [];
    const made = media ? media.faq : (Array.isArray(CONFIG.faq) ? CONFIG.faq : []);
    const seen = new Set(), out = [];
    for (const f of [...own, ...made]) {
      if (!f || !f.q || !f.a) continue;
      const k = String((f.q && (f.q.en || f.q.de)) || f.q).trim().toLowerCase();
      if (!k || seen.has(k)) continue;
      seen.add(k); out.push(f);
    }
    return out;
  };
  const pick = (v) => (v && typeof v === "object" ? (lang() === "de" ? v.de || v.en : v.en || v.de) : v);

  // ── Shadow DOM: nothing here can be restyled by the app, or restyle it ─────────────────────────
  const host = document.createElement("div");
  host.id = "oneadmin-help";
  const root = host.attachShadow({ mode: "open" });
  const CSS = `
    :host { all: initial; }
    * { box-sizing: border-box; font-family: var(--font, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif); }
    .btn { position: fixed; z-index: 2147483000; width: var(--btn-size, 34px); height: var(--btn-size, 34px);
      border-radius: var(--btn-radius, 50%); display: flex; align-items: center; justify-content: center; cursor: pointer;
      padding: 0; font-weight: 700; font-size: calc(var(--btn-size, 34px) * .5); line-height: 1;
      font-family: var(--btn-font, var(--font, system-ui, sans-serif));
      background: var(--btn-bg, transparent); color: var(--btn-fg, #888);
      border: var(--btn-border, 1.5px solid rgba(127,127,127,.45)); transition: opacity .15s, transform .15s; }
    .btn:hover { transform: scale(1.06); }
    .btn:focus-visible { outline: 2px solid var(--accent); outline-offset: 2px; }
    .btn.float { width: 46px; height: 46px; font-size: 20px; border-radius: 50%; border: none;
      background: var(--accent); color: var(--accent-fg); box-shadow: 0 6px 20px rgba(0,0,0,.3); }
    .btn.hidden { opacity: 0; pointer-events: none; }
    .overlay { position: fixed; inset: 0; z-index: 2147483001; background: rgba(0,0,0,.5); display: flex;
      align-items: center; justify-content: center; padding: 12px; }
    .panel { background: var(--bg); color: var(--fg); width: min(440px, 100%); max-height: min(86vh, 760px);
      overflow: auto; border-radius: calc(var(--radius) + 6px); padding: 16px; display: flex; flex-direction: column; gap: 12px;
      box-shadow: 0 20px 60px rgba(0,0,0,.4); font-size: 14px; line-height: 1.5; }
    @media (max-width: 560px) {
      .overlay { align-items: flex-end; padding: 0; }
      .panel { width: 100%; border-radius: calc(var(--radius) + 6px) calc(var(--radius) + 6px) 0 0; max-height: 88vh; }
    }
    .head { display: flex; align-items: center; gap: 8px; }
    .title { font-size: 18px; font-weight: 800; flex: 1; }
    .lang { display: inline-flex; background: var(--card); border-radius: var(--radius); padding: 3px; }
    .lang button { border: none; background: transparent; color: var(--sub); font-weight: 800; font-size: 12px;
      padding: 5px 9px; border-radius: calc(var(--radius) - 2px); cursor: pointer; }
    .lang button[aria-pressed="true"] { background: var(--accent); color: var(--accent-fg); }
    .x { border: none; background: var(--card); color: var(--fg); width: 32px; height: 32px; border-radius: 50%;
      font-size: 18px; cursor: pointer; }
    .card { background: var(--card); border-radius: var(--radius); padding: 12px 14px; }
    .label { font-size: 11px; font-weight: 800; letter-spacing: .06em; text-transform: uppercase; color: var(--sub); margin-bottom: 4px; }
    .q { width: 100%; display: flex; justify-content: space-between; gap: 10px; padding: 10px 0; border: none;
      background: transparent; color: var(--fg); font-weight: 700; font-size: 14px; text-align: left; cursor: pointer; }
    .q + .a { color: var(--sub); padding: 0 0 10px; font-size: 13px; }
    .faq > div + div { border-top: 1px solid var(--line); }
    .chev { transition: transform .2s; color: var(--sub); }
    .open .chev { transform: rotate(180deg); }
    .big { width: 100%; border: none; border-radius: var(--radius); padding: 12px 14px; cursor: pointer; font-weight: 800; font-size: 14px;
      background: var(--accent); color: var(--accent-fg); }
    .ok { display: flex; gap: 8px; align-items: center; font-weight: 700; }
    .hint { color: var(--sub); font-size: 13px; margin-top: 8px; }
    .share { display: flex; gap: 14px; align-items: center; }
    .qr { width: 116px; height: 116px; flex: 0 0 auto; border-radius: calc(var(--radius) - 2px); background: #fff; }
    .url { color: var(--sub); font-size: 12px; word-break: break-all; margin: 2px 0 8px; }
    .row { display: flex; gap: 8px; flex-wrap: wrap; }
    .small { border: 1px solid var(--line); border-radius: calc(var(--radius) - 2px); padding: 8px 12px; cursor: pointer;
      font-weight: 700; font-size: 13px; background: var(--bg); color: var(--fg); }
    .vid video { display: block; width: 100%; aspect-ratio: 16 / 10; background: #000; border-radius: calc(var(--radius) - 2px); }
    .vids { display: flex; gap: 6px; flex-wrap: wrap; margin-top: 8px; }
    .vids button[aria-pressed="true"] { background: var(--accent); color: var(--accent-fg); border-color: transparent; }
    .about div + div { margin-top: 2px; }
    .tag { color: var(--sub); font-style: italic; }
    a { color: var(--link); }
    .toast { position: fixed; left: 50%; bottom: 22px; transform: translateX(-50%); z-index: 2147483002; background: var(--fg);
      color: var(--bg); padding: 8px 14px; border-radius: var(--radius); font-weight: 600; font-size: 13px; }`;
  try {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(CSS);
    root.adoptedStyleSheets = [sheet];
  } catch {
    const s = document.createElement("style");
    s.textContent = CSS;
    root.appendChild(s);
  }

  const button = document.createElement("button");
  button.type = "button";
  button.className = "btn float hidden";
  button.style.right = "16px"; button.style.bottom = "16px";
  button.textContent = "?";
  root.appendChild(button);
  button.addEventListener("click", () => open(button));

  // ── The app's theme ──────────────────────────────────────────────────────────────────────────
  // Colours are read back through a 1×1 canvas, so whatever syntax the app wrote them in
  // (hex, rgb, hsl, oklch from Tailwind 4, a named colour) arrives as plain sRGB bytes.
  const px = document.createElement("canvas"); px.width = px.height = 1;
  const pctx = px.getContext("2d", { willReadFrequently: true });
  const rgba = (color) => {
    if (!pctx || !color || (window.CSS && CSS.supports && !CSS.supports("color", color))) return null;
    pctx.clearRect(0, 0, 1, 1); pctx.fillStyle = "#000"; pctx.fillStyle = color; pctx.fillRect(0, 0, 1, 1);
    const d = pctx.getImageData(0, 0, 1, 1).data;
    return { r: d[0], g: d[1], b: d[2], a: d[3] / 255 };
  };
  const css = (c, a = 1) => `rgba(${c.r},${c.g},${c.b},${a})`;
  const lum = (c) => { const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; }; return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b); };
  const contrast = (a, b) => { const x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); };
  const mix = (a, b, t) => ({ r: Math.round(a.r + (b.r - a.r) * t), g: Math.round(a.g + (b.g - a.g) * t), b: Math.round(a.b + (b.b - a.b) * t), a: 1 });
  const sat = (c) => { const mx = Math.max(c.r, c.g, c.b), mn = Math.min(c.r, c.g, c.b); return mx ? (mx - mn) / mx : 0; };
  const solidBg = (el) => {
    for (let e = el; e; e = e.parentElement) {
      const c = rgba(getComputedStyle(e).backgroundColor);
      if (c && c.a > 0.5) return c;
    }
    return { r: 255, g: 255, b: 255, a: 1 };
  };
  const readTheme = (bar) => {
    const bodyCs = getComputedStyle(document.body);
    const bg = solidBg(document.body);
    let fg = rgba(bodyCs.color) || (lum(bg) < 0.4 ? { r: 240, g: 240, b: 245, a: 1 } : { r: 25, g: 22, b: 35, a: 1 });
    if (contrast(fg, bg) < 3) fg = lum(bg) < 0.4 ? { r: 240, g: 240, b: 245, a: 1 } : { r: 25, g: 22, b: 35, a: 1 };
    // Accent: the app's own declaration first, then the most colourful button it draws.
    let accent = null;
    const rootCs = getComputedStyle(document.documentElement);
    for (const v of ["--accent", "--primary", "--color-primary", "--brand", "--color-accent", "--theme-color"]) {
      const c = rgba(rootCs.getPropertyValue(v).trim());
      if (c && c.a > 0.5 && sat(c) > 0.2) { accent = c; break; }
    }
    if (!accent) {
      const meta = document.querySelector('meta[name="theme-color"]');
      const c = meta && rgba(meta.getAttribute("content"));
      if (c && c.a > 0.5 && sat(c) > 0.25) accent = c;
    }
    if (!accent) {
      let best = null, bestSat = 0.3;
      for (const b of Array.from(document.querySelectorAll("button,[role=button],a")).slice(0, 80)) {
        const c = rgba(getComputedStyle(b).backgroundColor);
        if (c && c.a > 0.5 && sat(c) > bestSat) { best = c; bestSat = sat(c); }
      }
      accent = best;
    }
    if (!accent || contrast(accent, bg) < 1.4) accent = lum(bg) < 0.4 ? { r: 167, g: 139, b: 250, a: 1 } : { r: 109, g: 76, b: 230, a: 1 };
    const accentFg = contrast({ r: 255, g: 255, b: 255, a: 1 }, accent) >= contrast({ r: 20, g: 20, b: 20, a: 1 }, accent)
      ? "#ffffff" : "#141414";
    // Corner rounding: follow the app's controls — square apps get squarer cards.
    let radius = 14;
    const ctl = (bar || document.body).querySelector("button,[role=button],input");
    if (ctl) { const r = parseFloat(getComputedStyle(ctl).borderTopLeftRadius); if (!isNaN(r)) radius = Math.max(4, Math.min(18, r || 4)); }
    const vars = {
      "--bg": css(bg), "--fg": css(fg), "--card": css(mix(bg, fg, lum(bg) < 0.4 ? 0.08 : 0.05)),
      "--line": css(mix(bg, fg, 0.14)), "--sub": css(fg, 0.68), "--accent": css(accent), "--accent-fg": accentFg,
      "--link": css(contrast(accent, bg) >= 3 ? accent : fg), "--radius": `${radius}px`, "--font": bodyCs.fontFamily,
    };
    for (const [k, v] of Object.entries(vars)) host.style.setProperty(k, v);
  };
  // ── Who sees the button ──────────────────────────────────────────────────────────────────────
  const t0 = Date.now();
  // The app's own Supabase session, as the access module finds it.
  const appSession = () => {
    try {
      for (let i = 0; i < localStorage.length; i++) {
        const k = localStorage.key(i);
        if (!k || !/^sb-[a-z0-9]+-auth-token$/.test(k)) continue;
        const v = JSON.parse(localStorage.getItem(k) || "null");
        const s = v && (v.currentSession || v);
        if (s && s.access_token) return true;
      }
    } catch { /* storage off */ }
    return false;
  };
  const shown = () => {
    if (!showPart("button")) return false;          // the owner switched the floating button off
    const acc = window.oneadminAccess;
    // No access module (yet): give it a moment to load before deciding this app has no sign-in.
    if (!acc) return Date.now() - t0 > 1500;
    if (!acc.ready) return false;
    const st = acc.status;
    if (st && st.quiet) return false;              // a help video being recorded
    if (st && st.preview) return true;
    if (acc.active) return !!st;                   // OneAdmin's sign-up: signed-in people only
    if (typeof acc.ownSignIn === "function" && acc.ownSignIn()) return appSession();
    return true;
  };

  // ── Placement: the bottom-right corner ─────────────────────────────────────────────────────────
  const place = () => {
    const visible = !document.querySelector("[data-oneadmin-help]") && shown();
    if (visible) { try { readTheme(null); } catch { /* keep the last theme */ } }
    button.className = visible ? "btn float" : "btn float hidden";
    button.setAttribute("aria-label", L("Help & About", "Hilfe & Info"));
    button.title = L("Help & About", "Hilfe & Info");
  };
  let placeQueued = false;
  const queuePlace = (delay) => {
    if (placeQueued) return;
    placeQueued = true;
    const run = () => { placeQueued = false; if (!isOpen) place(); };
    delay ? setTimeout(run, delay) : requestAnimationFrame(run);
  };

  // An app's own help button: its click opens this panel instead of whatever it did before.
  // Capture phase on the document runs before any framework's handler on the app's root.
  document.addEventListener("click", (e) => {
    const t = e.target instanceof Element ? e.target.closest("[data-oneadmin-help]") : null;
    if (!t) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    open(t);
  }, true);

  // ── The panel ──────────────────────────────────────────────────────────────────────────────────
  let isOpen = false, overlay = null, opener = null, openFaq = -1, showInstallHint = false, toastTimer = 0;
  const toast = (msg) => {
    const old = root.querySelector(".toast"); if (old) old.remove();
    const t = document.createElement("div"); t.className = "toast"; t.textContent = msg; root.appendChild(t);
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.remove(), 2200);
  };
  const copyLink = async () => {
    try { await navigator.clipboard.writeText(link()); toast(L("Link copied", "Link kopiert")); }
    catch { toast(link()); }
  };
  const share = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: CONFIG.appName, url: link() }); } catch { /* cancelled */ }
      return;
    }
    copyLink();
  };
  const install = async () => {
    // The install pop-down (same file) holds the browser's offer once it has been made; ask through
    // it, so one offer is never used twice.
    const shared = window.oneadminInstall;
    if (shared && shared.canPrompt()) {
      deferredInstall = null;
      const r = await shared.prompt();
      if (r === "accepted") { toast(L(`Installing ${CONFIG.appName}…`, `${CONFIG.appName} wird installiert…`)); return; }
      if (r === "dismissed") return;
    }
    if (deferredInstall) {
      const e = deferredInstall; deferredInstall = null;
      try { await e.prompt(); const c = await e.userChoice; if (c && c.outcome === "accepted") toast(L(`Installing ${CONFIG.appName}…`, `${CONFIG.appName} wird installiert…`)); return; }
      catch { /* already used — fall through to the instructions */ }
    }
    showInstallHint = true; render();
  };

  // ── Videos: fetched from OneAdmin when the panel opens ───────────────────────────────────────
  let media = null, mediaAt = 0, playing = 0;
  const loadMedia = async () => {
    const m = CONFIG.media;
    if (!m || !m.api || !m.ref || Date.now() - mediaAt < 300_000) return;
    mediaAt = Date.now();
    try {
      const r = await fetch(m.api, { method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ app: m.ref, action: "help" }), signal: AbortSignal.timeout(8000) });
      const d = await r.json();
      if (d && d.ok) {
        media = {
          faq: Array.isArray(d.faq) ? d.faq : [],
          videos: (Array.isArray(d.videos) ? d.videos : []).filter((v) => v && /^https:\/\//.test(v.url)),
          show: d.show && typeof d.show === "object" ? d.show : null,
        };
        if (isOpen) render(); else queuePlace(0);
      }
    } catch { mediaAt = 0; }
  };

  const render = () => {
    if (!overlay) return;
    const name = esc(CONFIG.appName);
    const c = CONFIG.company || {};
    const items = faq();
    const plat = platform();
    const parts = [];
    parts.push(`<div class="head"><div class="title" id="oah-title">${esc(L("Help & About", "Hilfe & Info"))}</div>
      <span class="lang">${["en", "de"].map((l) => `<button type="button" data-lang="${l}" aria-pressed="${lang() === l}">${l.toUpperCase()}</button>`).join("")}</span>
      <button type="button" class="x" data-act="close" aria-label="${esc(L("Close", "Schließen"))}">×</button></div>`);
    // The signed-in person and their plan, when the app has OneAdmin's access module running
    // (Subscription Model → Activate Signup). Read from it, never stored here.
    const acc = window.oneadminAccess;
    const st = acc && acc.status;
    if (st && st.plan && !st.preview) {
      const own = typeof acc.ownSignIn === "function" && acc.ownSignIn();
      parts.push(`<div class="card"><div class="label">${esc(L("Account", "Konto"))}</div>
        ${st.email ? `<div><b>${esc(st.email)}</b></div>` : ""}
        <div>${esc(L("Plan", "Plan"))}: ${esc(st.plan.name)}${st.daysLeft != null ? ` · ${esc(st.state === "trial"
          ? L(`trial, ${st.daysLeft} day${st.daysLeft === 1 ? "" : "s"} left`, `Testphase, noch ${st.daysLeft} Tag${st.daysLeft === 1 ? "" : "e"}`)
          : L(`${st.daysLeft} day${st.daysLeft === 1 ? "" : "s"} left`, `noch ${st.daysLeft} Tag${st.daysLeft === 1 ? "" : "e"}`))}` : ""}</div>
        <div class="row" style="margin-top:8px"><button type="button" class="small" data-act="plans">${esc(L("Plans", "Pläne"))}</button>
          ${own ? "" : `<button type="button" class="small" data-act="signout">${esc(L("Sign out", "Abmelden"))}</button>`}</div></div>`);
    }
    const vids = showPart("videos") ? (media && media.videos) || [] : [];
    if (vids.length) {
      const v = vids[Math.min(playing, vids.length - 1)];
      parts.push(`<div class="card vid"><div class="label">${esc(L("How it works", "So funktioniert's"))}</div>
        <video src="${esc(v.url)}" controls playsinline preload="metadata" aria-label="${esc(pick(v.title))}"></video>
        <div class="hint">${esc(pick(v.title))}</div>
        ${vids.length > 1 ? `<div class="vids">${vids.map((x, i) => `<button type="button" class="small" data-vid="${i}" aria-pressed="${i === playing}">${esc(pick(x.title))}</button>`).join("")}</div>` : ""}</div>`);
    }
    if (items.length) {
      parts.push(`<div class="card faq"><div class="label">${esc(L("Questions", "Häufige Fragen"))}</div>${items.map((f, i) => `
        <div class="${openFaq === i ? "open" : ""}"><button type="button" class="q" data-faq="${i}" aria-expanded="${openFaq === i}">
          <span>${esc(pick(f.q))}</span><span class="chev">▾</span></button>
          ${openFaq === i ? `<div class="a">${esc(pick(f.a))}</div>` : ""}</div>`).join("")}</div>`);
    }
    if (!showPart("install")) { /* the owner left installing out */ }
    else if (isInstalled()) {
      parts.push(`<div class="card ok">✓ ${esc(L(`${CONFIG.appName} is installed on this device.`, `${CONFIG.appName} ist auf diesem Gerät installiert.`))}</div>`);
    } else if (installable()) {
      parts.push(`<div><button type="button" class="big" data-act="install">⬇ ${esc(L(`Install ${CONFIG.appName} on this device`, `${CONFIG.appName} auf diesem Gerät installieren`))}</button>
        ${showInstallHint ? `<div class="card hint">${esc(plat === "ios"
          ? L("On iPhone or iPad: open this page in Safari, tap the Share button, then “Add to Home Screen”.", "Auf iPhone oder iPad: Seite in Safari öffnen, auf „Teilen“ tippen, dann „Zum Home-Bildschirm“.")
          : plat === "android"
            ? L("Open your browser’s menu (⋮) and choose “Install app” or “Add to Home screen”.", "Öffne das Browser-Menü (⋮) und wähle „App installieren“ oder „Zum Startbildschirm hinzufügen“.")
            : L(`Look for the install icon at the right end of the address bar, or open the browser menu and choose “Install ${CONFIG.appName}”.`, `Suche das Installieren-Symbol rechts in der Adressleiste, oder wähle im Browser-Menü „${CONFIG.appName} installieren“.`))}</div>` : ""}</div>`);
    }
    const qr = CONFIG.qr && CONFIG.link ? `<svg class="qr" role="img" aria-label="${esc(L(`QR code for ${bare(link())}`, `QR-Code für ${bare(link())}`))}" viewBox="0 0 ${Number(CONFIG.qr.size)} ${Number(CONFIG.qr.size)}" shape-rendering="crispEdges"><path d="${esc(CONFIG.qr.path)}" fill="#1a1030"/></svg>` : "";
    if (showPart("share")) parts.push(`<div class="card share">${qr}<div style="min-width:0">
      <div class="label">${esc(L("Share this app", "Diese App teilen"))}</div>
      <div class="url">${esc(bare(link()))}</div>
      <div class="row"><button type="button" class="small" data-act="share">${esc(L("Share", "Teilen"))}</button>
        <button type="button" class="small" data-act="copy">${esc(L("Copy link", "Link kopieren"))}</button></div></div></div>`);
    const about = [`<div><b>${name}</b>${CONFIG.version ? ` v${esc(CONFIG.version)}` : ""}</div>`];
    if (c.name || c.email) about.push(`<div>${esc(c.name || "")}${c.name && c.email ? " · " : ""}${c.email ? `<a href="mailto:${esc(c.email)}">${esc(c.email)}</a>` : ""}</div>`);
    if (c.tagline) about.push(`<div class="tag">“${esc(c.tagline)}”</div>`);
    if (c.website) about.push(`<div><a href="${esc(c.website)}" target="_blank" rel="noopener noreferrer">${esc(bare(c.website))} ↗</a></div>`);
    parts.push(`<div class="card about"><div class="label">${esc(L("About", "Über"))}</div>${about.join("")}</div>`);
    overlay.firstElementChild.innerHTML = parts.join("");
  };

  const onKey = (e) => { if (e.key === "Escape") close(); };
  function open(from) {
    if (isOpen) return;
    isOpen = true; opener = from || null; openFaq = -1; showInstallHint = false;
    overlay = document.createElement("div");
    overlay.className = "overlay";
    overlay.innerHTML = `<div class="panel" role="dialog" aria-modal="true" aria-labelledby="oah-title"></div>`;
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) { close(); return; }
      const t = e.target instanceof Element ? e.target.closest("[data-act],[data-faq],[data-lang],[data-vid]") : null;
      if (!t) return;
      if (t.dataset.lang) {
        chosenLang = t.dataset.lang;
        try { localStorage.setItem(LANG_KEY, chosenLang); } catch { /* storage off */ }
        render(); return;
      }
      if (t.dataset.faq != null) { const i = Number(t.dataset.faq); openFaq = openFaq === i ? -1 : i; render(); return; }
      if (t.dataset.vid != null) { playing = Number(t.dataset.vid) || 0; render(); return; }
      const acc = window.oneadminAccess;
      if (t.dataset.act === "plans") { close(); acc?.openPlans?.(); return; }
      if (t.dataset.act === "signout") { close(); acc?.signOut?.(); return; }
      ({ close, install, share, copy: copyLink })[t.dataset.act]?.();
    });
    try { readTheme(null); } catch { /* keep the last theme */ }
    root.appendChild(overlay);
    render();
    void loadMedia();
    document.addEventListener("keydown", onKey, true);
    root.querySelector('[data-act="close"]')?.focus();
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    overlay?.remove(); overlay = null;
    document.removeEventListener("keydown", onKey, true);
    try { opener?.focus?.(); } catch { /* gone */ }
    queuePlace(0);
  }

  window.oneadminHelp = { open: () => open(null), close, version: 2 };
  // The plan or minutes changed while the panel is open: show the new ones.
  window.addEventListener("oneadmin-access", () => { if (isOpen) render(); queuePlace(0); });

  const start = () => {
    document.body.appendChild(host);
    place();
    // Ask once, early, whether the owner shows the button at all; it stays shown until told otherwise.
    void loadMedia();
    new MutationObserver(() => queuePlace(250)).observe(document.body, { childList: true, subtree: true });
    // A sign-in or sign-out in the app's own storage, and the moment the access module had to load.
    window.addEventListener("storage", () => queuePlace(0));
    setTimeout(() => queuePlace(0), 600); setTimeout(() => queuePlace(0), 1600); setTimeout(() => queuePlace(0), 3000);
  };
  if (document.body) start(); else document.addEventListener("DOMContentLoaded", start, { once: true });
})();


// ── OneAdmin install pop-down ────────────────────────────────────────────────────────────────
// "Add this app to your home screen", on phones and tablets: a small card that drops in from the
// top for a few seconds — never a dialog over the page, never at the bottom where the app's own
// controls and the browser's toolbar are.
//
// The two platforms are not alike and this does not pretend otherwise:
//  - Android (Chrome, Edge, Samsung…) hands the page a `beforeinstallprompt` event once the app is
//    installable: the card then has an Install button that opens the browser's own dialog. Caught
//    at import time, because it is offered once. When the browser offers none, the card says where
//    its menu entry is instead of staying silent — that silence was the "not always".
//  - iOS has no install API at all: the only way is Share → Add to Home Screen, so the card says so.
//
// Every time the app is opened: it comes, goes again on its own after a few seconds (or with ×),
// and comes back on the next load. Once the app is installed it stops for good. Off per app with
// CONFIG.install = false. Shares the browser's event with the help panel (window.oneadminInstall),
// and quiets the older full-screen prompt OneAdmin's first app scaffold put in some apps.
(() => {
  if (typeof window === "undefined" || typeof document === "undefined") return;
  if (CONFIG.install === false || window.__oneadminInstallLoaded) return;
  window.__oneadminInstallLoaded = true;

  const KEY_DONE = "oneadmin.install.installed";
  /** How long it stays when nobody touches it. */
  const SHOW_FOR_MS = 10000;
  const get = (s, k) => { try { return s.getItem(k); } catch { return null; } };
  const set = (s, k, v) => { try { s.setItem(k, v); } catch { /* storage off: shown again next visit */ } };
  // The older prompt (src/installPrompt.ts in apps OneAdmin first scaffolded) shows once a visit:
  // telling it this visit already had one keeps it from opening over the page as well.
  set(window.sessionStorage, "app-install-shown-v1", "1");

  let deferred = null;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();   // the browser's own mini-bar would be a second offer of the same thing
    deferred = e;
    if (card) render();
  });
  window.addEventListener("appinstalled", () => { deferred = null; set(window.localStorage, KEY_DONE, "1"); hide(); });

  const ua = () => navigator.userAgent || "";
  const platform = () => {
    if (/iPad|iPhone|iPod/.test(ua()) || (navigator.maxTouchPoints > 1 && /Macintosh/.test(ua()))) return "ios";
    if (/Android/i.test(ua())) return "android";
    return "desktop";
  };
  const installed = () => {
    try {
      return window.matchMedia("(display-mode: standalone)").matches || window.matchMedia("(display-mode: fullscreen)").matches
        || navigator.standalone === true || get(window.localStorage, KEY_DONE) === "1";
    } catch { return false; }
  };
  /** The browser's own dialog. "unavailable" when it has offered none. */
  const prompt = async () => {
    const e = deferred;
    if (!e) return "unavailable";
    deferred = null;
    try { await e.prompt(); const c = await e.userChoice; if (c && c.outcome === "accepted") set(window.localStorage, KEY_DONE, "1"); return (c && c.outcome) || "dismissed"; }
    catch { return "unavailable"; }
  };
  window.oneadminInstall = { version: 1, platform, installed, canPrompt: () => !!deferred, prompt };

  // ── When ───────────────────────────────────────────────────────────────────────────────────
  const recordingHelp = () => /oneadmin-help/.test(location.hash)
    || !!(window.oneadminAccess && window.oneadminAccess.status && window.oneadminAccess.status.quiet);
  const quiet = () => platform() === "desktop" || installed() || recordingHelp();

  // ── Words ──────────────────────────────────────────────────────────────────────────────────
  const de = () => {
    const s = get(window.localStorage, "oneadmin.helpLang");
    return s ? s === "de" : /^de\b/i.test(navigator.language || "");
  };
  const L = (en, d) => (de() ? d : en);
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
  const name = () => CONFIG.appName || (document.title || "").split(/[-–—|]/)[0].trim() || L("this app", "diese App");
  const SHARE = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" style="vertical-align:-2px"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M12 3v12M8 7l4-4 4 4M6 11H5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1h-1"/></svg>';
  const how = () => {
    if (platform() === "ios") {
      return /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua())
        ? L(`Tap Share ${SHARE}, then “Add to Home Screen” — or open this page in Safari.`, `Tippe auf Teilen ${SHARE}, dann „Zum Home-Bildschirm“ — oder öffne die Seite in Safari.`)
        : L(`Tap Share ${SHARE}, then “Add to Home Screen”.`, `Tippe auf Teilen ${SHARE}, dann „Zum Home-Bildschirm“.`);
    }
    return /SamsungBrowser/i.test(ua())
      ? L("Open the menu ☰ and choose “Add page to” → “Home screen”.", "Öffne das Menü ☰ und wähle „Seite hinzufügen zu“ → „Startbildschirm“.")
      : L("Open the browser menu ⋮ and choose “Install app” or “Add to Home screen”.", "Öffne das Browser-Menü ⋮ und wähle „App installieren“ oder „Zum Startbildschirm hinzufügen“.");
  };
  const icon = () => {
    for (const sel of ['link[rel~="apple-touch-icon"]', 'link[rel~="icon"][sizes="192x192"]', 'link[rel~="icon"][type="image/png"]', 'link[rel~="icon"]']) {
      const l = document.querySelector(sel);
      if (l && l.href && !/\.ico(\?|$)/i.test(l.href)) return l.href;
    }
    return "";
  };

  // ── Look: the page's own colours, read through a 1×1 canvas (any CSS colour syntax) ────────────
  const px = document.createElement("canvas"); px.width = px.height = 1;
  const pc = px.getContext("2d", { willReadFrequently: true });
  const rgba = (c) => {
    if (!pc || !c) return null;
    pc.clearRect(0, 0, 1, 1); pc.fillStyle = "#000"; pc.fillStyle = c; pc.fillRect(0, 0, 1, 1);
    const d = pc.getImageData(0, 0, 1, 1).data; return { r: d[0], g: d[1], b: d[2], a: d[3] / 255 };
  };
  const lum = (c) => { const f = (v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : ((v + 0.055) / 1.055) ** 2.4; }; return 0.2126 * f(c.r) + 0.7152 * f(c.g) + 0.0722 * f(c.b); };
  const sat = (c) => { const mx = Math.max(c.r, c.g, c.b), mn = Math.min(c.r, c.g, c.b); return mx ? (mx - mn) / mx : 0; };
  const theme = () => {
    let bg = null;
    for (let e = document.body; e && !bg; e = e.parentElement) { const c = rgba(getComputedStyle(e).backgroundColor); if (c && c.a > 0.5) bg = c; }
    bg = bg || { r: 255, g: 255, b: 255, a: 1 };
    const dark = lum(bg) < 0.4;
    let accent = null;
    const rs = getComputedStyle(document.documentElement);
    for (const v of ["--accent", "--primary", "--color-primary", "--brand", "--color-accent", "--theme-color"]) {
      const c = rgba(rs.getPropertyValue(v).trim()); if (c && c.a > 0.5 && sat(c) > 0.2) { accent = c; break; }
    }
    if (!accent) { const m = document.querySelector('meta[name="theme-color"]'); const c = m && rgba(m.getAttribute("content")); if (c && c.a > 0.5 && sat(c) > 0.25) accent = c; }
    accent = accent || (dark ? { r: 167, g: 139, b: 250 } : { r: 109, g: 76, b: 230 });
    return {
      bg: dark ? "rgba(28,28,34,.97)" : "rgba(255,255,255,.98)", fg: dark ? "#f2f2f5" : "#18161f",
      sub: dark ? "rgba(242,242,245,.7)" : "rgba(24,22,31,.66)", line: dark ? "rgba(255,255,255,.12)" : "rgba(0,0,0,.1)",
      accent: `rgb(${accent.r},${accent.g},${accent.b})`, accentFg: lum(accent) > 0.45 ? "#141414" : "#ffffff",
      font: getComputedStyle(document.body).fontFamily,
    };
  };

  // ── The card ───────────────────────────────────────────────────────────────────────────────
  let host = null, root = null, card = null, autoHide = 0;
  const CSS = `
    :host { all: initial; }
    * { box-sizing: border-box; }
    .card { position: fixed; z-index: 2147483001; left: 50%; top: calc(env(safe-area-inset-top, 0px) + 8px);
      width: min(420px, calc(100vw - 16px)); transform: translate(-50%, calc(-100% - 24px)); opacity: 0;
      transition: transform .32s cubic-bezier(.2,.9,.3,1.2), opacity .2s;
      display: flex; align-items: center; gap: 10px; padding: 9px 8px 9px 10px; border-radius: 14px;
      background: var(--bg); color: var(--fg); border: 1px solid var(--line); box-shadow: 0 10px 30px rgba(0,0,0,.28);
      font: 13px/1.35 var(--font, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif); -webkit-backdrop-filter: blur(10px); backdrop-filter: blur(10px); }
    .card.in { transform: translate(-50%, 0); opacity: 1; }
    .ic { width: 36px; height: 36px; border-radius: 9px; flex: none; object-fit: cover; background: var(--line); }
    .txt { flex: 1; min-width: 0; }
    .t { font-weight: 650; font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .s { color: var(--sub); font-size: 12px; margin-top: 1px; }
    .go { flex: none; border: 0; border-radius: 9px; padding: 8px 12px; font: 600 13px var(--font, system-ui, sans-serif);
      background: var(--accent); color: var(--accent-fg); cursor: pointer; }
    .x { flex: none; width: 28px; height: 28px; border: 0; background: none; color: var(--sub); font-size: 18px; line-height: 1; cursor: pointer; border-radius: 8px; }
    .x:focus-visible, .go:focus-visible { outline: 2px solid var(--accent); outline-offset: 2px; }
    @media (prefers-reduced-motion: reduce) { .card { transition: opacity .2s; } }
  `;
  const render = () => {
    if (!card) return;
    const src = icon();
    const can = !!deferred;
    card.innerHTML = `${src ? `<img class="ic" alt="" src="${esc(src)}">` : ""}
      <div class="txt"><div class="t">${esc(L(`Install ${name()}`, `${name()} installieren`))}</div>
        <div class="s">${can ? esc(L("Opens like an app — its own icon, full screen.", "Öffnet wie eine App — eigenes Symbol, ganzer Bildschirm.")) : how()}</div></div>
      ${can ? `<button type="button" class="go" data-act="go">${esc(L("Install", "Installieren"))}</button>` : ""}
      <button type="button" class="x" data-act="x" aria-label="${esc(L("Close", "Schließen"))}">×</button>`;
  };
  function hide() {
    if (!card) return;
    clearTimeout(autoHide);
    card.classList.remove("in");
    const h = host; card = null;
    setTimeout(() => h && h.remove(), 400);
  }
  const show = () => {
    if (card || quiet()) return;
    host = document.createElement("div");
    host.id = "oneadmin-install";
    root = host.attachShadow({ mode: "open" });
    const t = theme();
    const style = document.createElement("style");
    style.textContent = CSS;
    root.appendChild(style);
    card = document.createElement("div");
    card.className = "card";
    card.setAttribute("role", "dialog");
    card.setAttribute("aria-label", L("Install this app", "Diese App installieren"));
    for (const [k, v] of Object.entries({ "--bg": t.bg, "--fg": t.fg, "--sub": t.sub, "--line": t.line, "--accent": t.accent, "--accent-fg": t.accentFg, "--font": t.font })) card.style.setProperty(k, v);
    root.appendChild(card);
    render();
    card.addEventListener("click", async (e) => {
      const act = e.target && e.target.closest ? e.target.closest("[data-act]") : null;
      if (!act) return;
      if (act.dataset.act === "x") { hide(); return; }   // for now — the next load offers it again
      const r = await prompt();
      if (r === "accepted") hide(); else if (card) render();
    });
    // Touched while it is up (reading it, about to press Install): it stays until closed.
    card.addEventListener("pointerdown", () => clearTimeout(autoHide));
    (document.body || document.documentElement).appendChild(host);
    requestAnimationFrame(() => requestAnimationFrame(() => card && card.classList.add("in")));
    autoHide = setTimeout(hide, SHOW_FOR_MS);
  };

  // After the page has settled; on Android a moment longer, so the browser's own offer can arrive
  // and the card has its Install button rather than menu directions.
  const start = () => setTimeout(() => { if (platform() !== "android" || deferred) show(); else setTimeout(show, 3500); }, 2500);
  if (document.readyState === "complete") start(); else window.addEventListener("load", start, { once: true });
})();
